import { Component } from 'react'
import PropTypes from 'prop-types'

export default class WindowListener extends Component {
  constructor(props) {
    super(props)

    this.listeners = Object.keys(props)
      .filter(p => p.startsWith('on'))
      .map(p => [p.charAt(2).toLocaleLowerCase() + p.substring(3), p])
  }

  componentDidMount() {
    this.listeners.forEach(([event, handlerProp]) =>
      window.addEventListener(event, this.props[handlerProp])
    )
  }

  componentWillUnmount() {
    this.listeners.forEach(([event, handlerProp]) =>
      window.removeEventListener(event, this.props[handlerProp])
    )
  }

  componentDidUpdate(oldProps) {
    this.listeners.forEach(([event, handlerProp]) => {
      if (this.props[handlerProp] !== oldProps[handlerProp]) {
        window.removeEventListener(event, oldProps[handlerProp])
        window.addEventListener(event, this.props[handlerProp])
      }
    })
  }

  render() {
    return <>{this.props.children}</>
  }
}

WindowListener.propTypes = {
  children: PropTypes.node,
}
